export default "__VITE_ASSET__AmygBcF8__"